import { z } from "zod";
import dayjs, { type Dayjs } from "dayjs";
export const DayjsSchema = z.custom<Dayjs>((val) => dayjs.isDayjs(val), { message: "Invalid date instance" });

export const FormSchema = z.object({
  branch_id: z.number(),
  employee_id: z.number("Выбор специалиста обязателен"),
  duration: z.number(),
  date: DayjsSchema,
  start_time: z.string("Выбор времени записи обязателен"),
  end_time: z.string("Выбор времени записи обязателен"),
  reason: z.string("Причина записи обязательна").optional(),
  customer: z.object({
    first_name: z.string("Укажите ваше имя"),
    last_name: z.string().optional(),
    phone_number: z.string("Укажите ваш номер телефона"),
    email: z.email().optional(),
  }),
});
export type FormValues = z.infer<typeof FormSchema>;
